import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import { debounce } from "../helpers";
export default class Filter {
  constructor() {
    this.filterForm = document.querySelector(".filter-tree__form");
    this.initialise();
  }

  initialise() {
    this.formData = new FormData();

    this.debouncedSubmit = debounce((e) => {
      if (
        !e.target.classList.contains("filter-accordion__toggle") &&
        !e.target.classList.contains("js-active-filter-checkbox")
      ) {
        this.filterProducts();
      }
    }, 500);

    this.filterForm.addEventListener("input", this.debouncedSubmit.bind(this));

    this.observeActiveFilters();
    this.handleActiveFilters();
    this.initialiseSliders({ target: ".ui-slider-wrap" });
  }

  observeActiveFilters() {
    const callback = (mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          this.handleActiveFilters();
        }
      });
    };

    const activeFilters = document.querySelector(".js-active-filters");
    const observer = new MutationObserver(callback);
    observer.observe(activeFilters, { childList: true });
  }

  handleActiveFilters() {
    document
      .querySelectorAll(".js-active-filters a[data-id]")
      .forEach((elem) => {
        elem.addEventListener("click", (e) => {
          this.toggleActiveFilter(e);
        });
      });
  }

  toggleActiveFilter(e) {
    e.preventDefault();
    const filter = e.target.dataset.id;
    const filterInput = this.filterForm.querySelector(`input[id="${filter}"]`);
    filterInput.click();
  }

  // Handle NoUiSlider
  initialiseSliders({ destroy = false, target = null }) {
    if (!target)
      return console.warn("Cannot initialise slider without a target");

    document.querySelectorAll(target).forEach((sliderWrap) => {
      const sliderBase = sliderWrap.querySelector(".noUi-target");
      const sliderElem = sliderWrap.querySelector(".ui-slider");

      if (!sliderElem.dataset.sliderConfig) {
        console.warn(
          "Please provide config via the data-slider-config attribute"
        );
        return;
      }

      const config = JSON.parse(sliderElem.dataset.sliderConfig);

      if (sliderBase && destroy) {
        sliderBase.noUiSlider.destroy();
      }

      const slider = noUiSlider.create(sliderElem, config);

      slider.on("update", (values, handle) => {
        document.querySelectorAll("input.ui-slider-value")[handle].value =
          values[handle];
      });

      slider.on("change", () => {
        this.filterForm.dispatchEvent(new Event("input"));
      });
    });
  }

  async filterProducts() {
    const collectionProductGrid = document.querySelector(
      ".collection__product-grid-wrap"
    );
    const productCount = document.querySelector(".collection-hero-bar__count");
    const productCountMobile = document.querySelector(
      ".collection-hero-bar--mobile"
    );
    const activeFilters = document.querySelector(".js-active-filters");

    try {
      collectionProductGrid.classList.add("collection__product-grid--loading");
      this.formData = new FormData(this.filterForm);
      const queryString = new URLSearchParams(this.formData);

      this.filterForm.classList.add("filter-tree--disabled");
      const { origin, pathname } = window.location;
      const checkedAccordions = [
        ...this.filterForm.querySelectorAll(
          ".filter-tree__option-toggle:checked"
        ),
      ].map((elem) => elem.id);

      const url =
        origin +
        pathname +
        (queryString.toString().length > 0 ? `?${queryString}` : "");

      const res = await fetch(url);

      if (res.ok) {
        await res.text().then((html) => {
          const wrap = document.createElement("div");
          wrap.innerHTML = html;
          const updatedCollectionProductGrid = wrap.querySelector(
            ".collection__product-grid-wrap"
          );
          const updatedProductCount = wrap.querySelector(
            ".collection-hero-bar__count"
          );
          const updatedProductCountMobile = wrap.querySelector(
            ".collection-hero-bar--mobile"
          );
          const updatedActiveFilters = wrap.querySelector(".js-active-filters");
          const updatedFilterForm = wrap.querySelector(".filter-tree__form");

          for (const id of checkedAccordions) {
            const target = wrap.querySelector(
              `.filter-tree__option-toggle#${id}`
            );
            if (target) target.setAttribute("checked", true);
          }

          collectionProductGrid.innerHTML =
            updatedCollectionProductGrid.innerHTML;
          productCount.innerHTML = updatedProductCount.innerHTML;
          productCountMobile.innerHTML = updatedProductCountMobile.innerHTML;
          productCount.innerHTML = updatedProductCount.innerHTML;
          activeFilters.innerHTML = updatedActiveFilters.innerHTML;

          this.filterForm
            .querySelectorAll(".filter-accordion__inner")
            .forEach((accordion, i) => {
              if (updatedFilterForm) {
                const item = updatedFilterForm.querySelectorAll(
                  ".filter-accordion__inner"
                )[i];
                if (item && !item.classList.contains("filter-accordion__price"))
                  accordion.innerHTML = item.innerHTML;
              }
            });

          history.replaceState(
            {},
            "",
            url || `${window.location.pathname}?${queryString.toString()}`
          );
          this.filterForm.classList.remove("filter-tree--disabled");
        });
        collectionProductGrid.classList.remove(
          "collection__product-grid--loading"
        );
      } else {
        console.error("There was an error:", res.status);
      }
    } catch (error) {
      console.error("There was an error:", error);
    }
  }
}
